import { render, staticRenderFns } from "./ProductShowcaseFeature.vue?vue&type=template&id=bd109c64&"
import script from "./ProductShowcaseFeature.vue?vue&type=script&lang=js&"
export * from "./ProductShowcaseFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports